import type {Components, Theme} from '@mui/material/styles';
import {COLORS} from '~/style/colors-ts';

export const listOverrides: Components<Theme>['MuiList'] = {
    styleOverrides: {
        root: ({theme}) => ({
            '&.menuList': {
                padding: theme.spacing(1),
                '& .MuiListItemIcon-root': {
                    minWidth: '18px',
                    marginRight: '12px',
                    // color: COLORS.grey[700],
                    // TODO: change to design system variable when we have the correct color
                    color: '#44474E'
                },
                '& .MuiListItem-root': {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1),
                },
                '& .MuiListItemButton-root': {
                    paddingLeft: theme.spacing(1.5),
                    paddingRight: theme.spacing(1.5),
                    paddingTop: theme.spacing(1),
                    paddingBottom: theme.spacing(1),
                    '&:has(.MuiListItemText-root):not(:has(.MuiListItemText-secondary))': {
                        height: '36px',
                    },
                    '&.Mui-selected, &:hover': {
                        borderRadius: '8px',
                    },
                },
                '& .MuiListSubheader-root': {
                    fontSize: '12px',
                },
            },
        }),
    },
};

export const listItemTextOverrides: Components<Theme>['MuiListItemText'] = {
    styleOverrides: {
        root: {
            minWidth: 0,
        },
        primary: {
            fontSize: '14px',
            fontWeight: 400,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        secondary: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
};
